import React from 'react';
import PostList from '../features/posts/PostList';

const Posts = () => {
    return (
        <div>
            <PostList />
        </div>
    );
};

export default Posts;